import StarBorderIcon from "@mui/icons-material/StarBorder";
import { type FC, useCallback } from "react";

import { useWatchlist } from "~/feature/watchlist/providers/WatchlistProvider";
import { useFilter } from "~/providers/FilterProvider";

import * as Styled from "./WatchlistFilterChip.styles";

export const WatchlistFilterChip: FC = () => {
  const { watchlistIds } = useWatchlist();
  const { isWatchlistOnly, setWatchlistOnly } = useFilter();

  const handleClick = useCallback(
    () => setWatchlistOnly(!isWatchlistOnly),
    [isWatchlistOnly, setWatchlistOnly]
  );

  return (
    <Styled.Chip
      active={isWatchlistOnly}
      aria-pressed={isWatchlistOnly}
      onClick={handleClick}
    >
      <StarBorderIcon />
      Watchlist
      {watchlistIds.length > 0 && (
        <Styled.Count>{watchlistIds.length}</Styled.Count>
      )}
    </Styled.Chip>
  );
};
